import { render, staticRenderFns } from "./FullDonutCountry.vue?vue&type=template&id=28e755c6&scoped=true&"
import script from "./FullDonutCountry.vue?vue&type=script&lang=js&"
export * from "./FullDonutCountry.vue?vue&type=script&lang=js&"
import style0 from "./FullDonutCountry.vue?vue&type=style&index=0&id=28e755c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e755c6",
  null
  
)

export default component.exports